import numeral from 'numeral';

export const currencyFormat = '$0,0.00';
export const currencyWithoutDecimalFormat = '$0,0';

export const centsToCurrency = (cents: number, format = currencyFormat, floor = false): string => {
  const value = cents / 100;
  return numeral(floor ? Math.floor(value) : value).format(format);
};
